import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';

export const IconInStock = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7814 0.466269L5.59338 9.65427L2.19938 6.27927C2.11861 6.20201 2.01115 6.15889 1.89938 6.15889C1.78761 6.15889 1.68015 6.20201 1.59938 6.27927L0.620382 7.25827C0.543122 7.33904 0.5 7.4465 0.5 7.55827C0.5 7.67004 0.543122 7.7775 0.620382 7.85827L5.29438 12.5323C5.37515 12.6095 5.48261 12.6527 5.59438 12.6527C5.70615 12.6527 5.81361 12.6095 5.89438 12.5323L16.3794 2.04627C16.4566 1.9655 16.4998 1.85804 16.4998 1.74627C16.4998 1.6345 16.4566 1.52704 16.3794 1.44627L15.3994 0.466269C15.3149 0.389323 15.2047 0.34668 15.0904 0.34668C14.9761 0.34668 14.8659 0.389323 14.7814 0.466269Z"
      fill="#33913A"
    />
  </svg>
);
